export * as React from 'react'

new EventSource('/esbuild').addEventListener('change', () => location.reload())